import { NextPage } from 'next'
import { useState } from 'react'
import { FaBookmark } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { ArticleList } from 'web_core/assets/article/List'
import { CategorySelector } from 'web_core/assets/category'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useAuthState } from 'web_core/firebase/hooks'
import { useESArticles } from 'web_core/hooks/models'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { ContentNavSelector } from '~/components/Utils/ContentNavSelector'
import { Heading } from '~/components/Utils/Heading'
import { useLayoutProperty } from '~/context/layout_property'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  const { user } = useAuthState()
  const [categoryId, setCategoryId] = useState<string>()
  const { articles, loadMore, isReachingEnd, isLoadingMore } = useESArticles(
    user ? { type: 'bookmarks', category_id: categoryId } : null
  )

  const { headerHeight } = useLayoutProperty()

  return (
    <DefaultLayout
      head={{ title: 'ブックマークした記事', index: false }}
      leftSidebar
      rightSideBar
      categoriesMenu={{ pc: true, sp: true }}
      navLinks={{ pc: true, tablet: true, sp: true }}
    >
      <Heading title="ブックマーク" icon={FaBookmark} className="mb-0" />
      <div
        className="sticky-top bg-white pt-2 pb-2 mb-2 mb-md-4"
        style={{ top: headerHeight }}
      >
        <ContentNavSelector
          active="articles"
          link="/bookmarks/[contents]"
          className="mb-2 mb-md-4"
        />
        <CategorySelector
          className="fs-7"
          style={{ maxWidth: 300 }}
          value={categoryId}
          onChange={setCategoryId}
          undefinedLabel={'全てのカテゴリ'}
        />
      </div>
      <InfiniteScroll
        loadMore={async () => {
          if (
            isLoadingMore === false &&
            isReachingEnd === false &&
            isReachingEnd === false
          )
            await loadMore()
        }}
        hasMore={isReachingEnd === false}
        loader={<LoadingSpinner />}
      >
        {articles && (
          <ArticleList
            articles={articles}
            className="grid g-cols-1 g-m-cols-2"
          />
        )}
      </InfiniteScroll>
    </DefaultLayout>
  )
}

export default Page
